import { environment } from 'src/environments/environment';

export class AppConstants {
    public static UseMock = false;

    public static FederaleURL = {
        MyFederale: environment.myFederale,
        WWWFederale: environment.wwwFederale
    };

    public static Languages = {
        // AllLanguages: ['EN', 'FR', 'NL'],
        AllLanguages: ['FR', 'NL'],
        DefaultLanguage: 'FR'
    };

    public static APIURLS = {
        GetDecryptedId: 'GetDecryptedId?clientId=',
        GetContactDetails: 'GetContactDetails',
        GetMaximumCapital: 'GetMaximumCapitalBatiment',
        GetMinimumPremium: 'GetMinimumPremium',
        GetSimulation: 'api/Simulation/GetSimulation',
        SaveSimulation: 'api/Simulation/SaveSimulation',
        GetNextSimulation: 'api/Simulation/GetNextSimulation',
        GetAddress: 'api/Address/GetAddress?addressCode=',
        GetCountry: 'api/Address/GetCountry?addressCode=',
        GetEvaluationTarification: 'api/Simulation/GetEvaluationTarification',
        GetCancellationTemplateLocation: 'api/Simulation/GetCancellationTemplateLocation?templateLanguage=',
        GetUpdatedEvaluationTarification: 'api/Simulation/GetUpdatedEvaluationTarification',
        GetOfficeLocation: 'api/Address/GetLocations',
        GetIntermediate: 'api/Address/GetIntermediateNo',
        GetCodeLocalite: 'api/Address/GetCodeLocalite',
        ValidateDigitalSignature: 'api/Signature/ValidateDigitalSignature',
        SaveSignedDocument: 'api/Signature/SaveSignedDocument',
        SaveIdDocument: 'api/Signature/SaveIdDocument',
        RetrieveSimulation: 'api/Simulation/RetrieveSimulation',
        GetServerTime: 'api/Languages/GetServerTime',
        SavePDFDocument: 'api/Simulation/SaveFile',
        GetPDFDocument: 'api/Simulation/RetriveBytes'
    };

    public static MockURLS = {
        GetDecryptedId: '../../data/GetDecryptedId.json',
        GetContactDetails: '../../data/GetContactDetails.json',
        GetMaximumCapital: '../../data/GetMaximumCapital.json',
        GetSimulation: '../../data/GetSimulation.json',
        SaveSimulation: '../../data/SaveSimulation.json',
        GetNextSimulation2Point1: '../../data/GetNextSimulation2Point1.json',
        GetNextSimulation2Point2: '../../data/GetNextSimulation2Point2.json',
        GetAddress: 'api/Address/GetAddress?addressCode=',
        GetEvaluationTarification: '../../data/GetEvaluationTarification.json',
        GetUpdatedEvaluationTarification: '../../data/GetUpdatedEvaluationTarification.json',
        RetrieveSimulation: '../../data/RetrieveSimulation.json'
    };

    public static SectionConstants = {
        Section1: 'S1',
        Section2Point1: 'S2.1',
        Section2Point2: 'S2.2'
    };

    public static GroupConstants = {
        Group1: 'G1',
        Group2: 'G2',
        Group3: 'G3',
        Group4: 'G4',
        Group5: 'G5'
    };

    public static LocalStorage = {
        CharacteristicQuestionsSelectedList: 'CharacteristicQuestionsSelectedList'
    };

    public static SimulationReservationReason = {
        OtherProperty: { ID: 1, Text: 'OTHER PROPERTY' },
        OtherTaker: { ID: 2, Text: 'OTHER TAKER' },
        RSR: { ID: 3, Text: 'RSR' },
        AcceptanceCriteria: { ID: 4, Text: 'ACCEPTANCE CRITERIA' },
        GridCriteria: { ID: 5, Text: 'GRID CRITERIA' },
        BuildingCapital: { ID: 6, Text: 'BUILDING CAPITAL' },
        SecondHomeContent: { ID: 7, Text: 'SECOND HOME CONTENT' },
        ContentCapital: { ID: 8, Text: 'CONTENT CAPITAL' },
        BuildingProperty: { ID: 9, Text: 'BUILDING PROPERTY' },
        SpecificRequest: { ID: 10, Text: 'SPECIFIC REQUEST' },
        ProjectReserved: { ID: 11, Text: 'PROJECT RESERVED' },
        MinimumPremium: {ID: 12, Text: 'MINIMUM PREMIUM'}
    };

    public static PhoneNumberRegexPatterns = [
        new RegExp('^((0\\d{1,3}(\\s|\\/|\\.)?)|((\\+|00)\\d{2,3}(\\s|\\.)?\\d{1,3}(\\s|\\.)?))\\d{2,3}(\\s|\\.)?\\d{2}(\\s|\\.)?\\d{2}$')
        // new RegExp('^(0)[0-9]{1}[\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(04)?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(\\\+)[0-9]{2}[\\s]?[0-9][\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(00)[0-9]{2}[\\s]?[0-9][\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(\\\+)[0-9]{2}[\\s]?(4)[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(00)[0-9]{2}[\\s]?(4)[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(0)[0-9]{1}[\/][0-9]{3}[\.][0-9]{2}[\.][0-9]{2}$'),
        // new RegExp('^(0)[0-9]{1}[\.][0-9]{3}[\.][0-9]{2}[\.][0-9]{2}$'),
        // new RegExp('^(\\\+)[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),

        // new RegExp('^(0)[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(\\\+32)[\\s]?[0-9]{1}[\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // // // // new RegExp('^(00)[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(00)[0-9]{2}[\\s]?[0-9]{1}[\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(\\\+32)[\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$'),
        // new RegExp('^(00)[0-9]{2}[\\s]?[0-9]{3}[\\s]?[0-9]{2}[\\s]?[0-9]{2}[\\s]?[0-9]{2}$')
    ];

    // public static EmailIdRegexPattern = new RegExp('^[A-Za-z0-9._%+-]+@[A-za-z0-9.-]+\.[A-Za-z]{2,4}$');

    public static EmailIdRegexPattern = new RegExp('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$');
}

